"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adaptor34 = void 0;
const hasher_1 = require("../hasher");
const requests_1 = require("./requests");
const responses_1 = require("./responses");
exports.adaptor34 = {
    params: requests_1.Params,
    responses: responses_1.Responses,
    hashTx: hasher_1.hashTx,
    hashBlock: hasher_1.hashBlock,
};
